import styled from 'styled-components'

import { ResponsiveImage, TypeStyle } from '@syconium/little-miss-figgy'
import { fromMd } from '@syconium/little-miss-figgy/dist/constants'

export const CompleteTheSetWrap = styled.div`
  padding: ${o => o.theme.spacing(5)} ${o => o.theme.spacing(4)} ${o => o.theme.spacing(4)};

  ${fromMd} {
    border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
    padding: ${o => o.theme.spacing(5)} 0 ${o => o.theme.spacing(4)};
  }
`

export const Title = styled(TypeStyle.HeadlineMicro)`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  text-transform: uppercase;
`

export const Details = styled.div`
  display: flex;
  padding: ${o => o.theme.spacing(4)} 0;
`

export const Thumbnail = styled(ResponsiveImage)`
  width: 82px;
  height: 98px;
`

export const DetailsText = styled.div`
  padding: 0 14px;
`

export const ProductName = styled(TypeStyle.BodyDefault)`
  font-weight: ${o => o.theme.typography.font.weight[700]};
`

export const ColorText = styled(TypeStyle.BodyMicro)`
  color: ${o => o.theme.color.text.secondary.on.background};
`

export const SelectWrap = styled.div<{
  $fullWidth: boolean
}>`
  display: grid;
  grid-template-columns: ${o => (o.$fullWidth ? '1fr' : '1fr 1fr')};
  gap: ${o => o.theme.spacing(2)};
  padding-bottom: ${o => o.theme.spacing(4)};
  text-transform: capitalize;
`
